import { browser } from '$app/environment';
import NudgeAjax from '@ajax/nudge';
import Cookie from 'js-cookie';

let data = {};
let subscribeFns = {};

const setup = async function () {
  if (!browser) {
    return;
  }

  data = await NudgeAjax.index();
  runAllSubscribeFns();
};

const hide = async function (user, key) {
  if (!browser || (user && !user.benable_user && Cookie.get('benable-user') === 'true')) {
    return;
  }

  if (data && data[key]) {
    data[key] = false;
    data = await NudgeAjax.update({ [key]: false });
    runAllSubscribeFns();
  }
};

const get = function (key) {
  if (!browser) {
    return;
  }
  return data && data[key];
};

const subscribe = function (key, fn) {
  if (!browser) {
    return () => {};
  }
  subscribeFns[key] = subscribeFns[key] || [];
  subscribeFns[key].push(fn);

  return () => {
    subscribeFns[key] = subscribeFns[key].filter((subFn) => subFn !== fn);
  };
};

const runAllSubscribeFns = function () {
  if (!browser) {
    return;
  }

  for (let key in data) {
    runSubscribeFns(key, data[key]);
  }
};

const runSubscribeFns = function (key, value) {
  if (!browser) {
    return;
  }

  if (subscribeFns[key]) {
    try {
      subscribeFns[key].forEach((fn) => fn(value));
    } catch {}
  }
};

export default {
  setup: setup,
  hide: hide,
  get: get,
  subscribe: subscribe,
};
